import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['customAmountField', 'customAmountInput', 'fullRefundRadio', 'customAmountRadio']
  static values = {
    maxAmount: Number
  }

  connect() {
    this.toggleCustomField()
  }

  selectFullRefund() {
    this.toggleCustomField()
  }

  selectCustomAmount() {
    this.toggleCustomField()
    if (this.hasCustomAmountInputTarget) {
      this.customAmountInputTarget.focus()
    }
  }

  toggleCustomField() {
    const isCustom = this.hasCustomAmountRadioTarget && this.customAmountRadioTarget.checked

    if (this.hasCustomAmountFieldTarget) {
      this.customAmountFieldTarget.classList.toggle('d-none', !isCustom)
    }

    if (this.hasCustomAmountInputTarget) {
      this.customAmountInputTarget.required = isCustom
      if (!isCustom) {
        this.customAmountInputTarget.value = ''
      }
    }
  }

  validateAmount(event) {
    const input = event.target
    const value = parseFloat(input.value)
    const max = this.maxAmountValue

    if (value > max) {
      input.setCustomValidity(`Amount cannot exceed $${max.toFixed(2)}`)
    } else if (value <= 0) {
      input.setCustomValidity('Amount must be greater than $0.00')
    } else {
      input.setCustomValidity('')
    }
  }
}
